'use strict';

/**
 * Get query string param by name
 * window.location.search()
 *
 * @param name - String of param name
 * @return {string} value or empty string if not found
 */
module.exports = function (name) {
	var regexS = '[\\?&]' + name + '=([^&#]*)';
	var regex = new RegExp(regexS);
	var results = regex.exec(window.location.search);

	if (results === null) return '';
	else return decodeURIComponent(results[1].replace(/\+/g, ' '));
}